import Image from 'next/image';
import Link from 'next/link';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import styles from './JewelryCollections.module.css';
import { AWS_URL } from '@/constants';
import { GET_THREE_CARD } from '@/graphql/queries';


// ── Helper ────────────────────────────────────────────────────────────
const getImageUrl = (file) => {
  if (file?.path) return `${AWS_URL}${file.path}`;
  return null;
};

// ── Skeleton ──────────────────────────────────────────────────────────
function Skeleton() {
  return (
    <div className={styles.grid}>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className={i === 1 ? `${styles.collectionCard} ${styles.cardCenterEl}` : styles.collectionCard}
          style={{ background: '#f0ece4', animation: 'pulse 1.5s ease-in-out infinite' }}
        />
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────
export default function JewelryCollections() {
  const { data, loading, error } = useQuery(GET_THREE_CARD, {
    variables: { where: { type: { _eq: 'THREE_CARDS' } } },
    fetchPolicy: 'network-only',
  });

  const metas =
    data?.tenant_org_web_configuration?.[0]?.web_configuration_meta || [];

  // Map DB rows to the shape the render expects
  const collections = metas.map((meta, i) => ({
    src:         getImageUrl(meta.file),
    alt:         meta.title || `Card ${i + 1}`,
    href:        meta.redirection_url || '#',
    isMiddle:    i === 1,
    wrapperClass: i === 1
      ? `${styles.collectionCard} ${styles.cardCenterEl}`
      : styles.collectionCard,
  }));

  return (
    <div className={styles.container}>
      {loading && <Skeleton />}

      {!loading && !error && collections.length > 0 && (
        <div className={styles.grid}>
          {collections.map((col) => {
            const card = (
              <Link
                key={col.alt}
                href={col.href}
                className={col.wrapperClass}
                style={{ display: 'block', textDecoration: 'none' }}
              >
                {col.src && (
                  <Image
                    src={col.src}
                    alt={col.alt}
                    fill
                    sizes="(max-width: 1024px) 100vw, 33vw"
                    className={styles.image}
                    priority
                  />
                )}
              </Link>
            );

            if (col.isMiddle) {
              return (
                <div key={col.alt} className={styles.middleColumn}>
                  {card}
                  <div className={styles.browseSection}>
                    <Link href="/category/all-silver" style={{ textDecoration: 'none' }}>
                      <button className={styles.browseButton}>
                        Browse all Collections
                      </button>
                    </Link>
                  </div>
                </div>
              );
            }

            return card;
          })}
        </div>
      )}
    </div>
  );
}